import React, { memo, useEffect, useRef, useState } from "react";
import { useTranslation } from "react-i18next";
import AboutImg from "../assets/Images/aboutImg.png";
import SvgFilled from "../assets/Images/Frame27.svg";

// data driven by i18n
const carouselData = (t) => [
  {
    image: "./Images/Slider 1.png",
    title: t("home.carousel.1.title"),
    description: t("home.carousel.1.desc"),
    linkText: t("home.carousel.1.cta")
  },
  {
    image: "./Images/outdoor.png",
    title: t("home.carousel.2.title"),
    description: t("home.carousel.2.desc"),
    linkText: t("home.carousel.2.cta")
  },
  {
    image: "./Images/indoor.png",
    title: t("home.carousel.3.title"),
    description: t("home.carousel.3.desc"),
    linkText: t("home.carousel.3.cta")
  },
  {
    image: "./Images/hotel.png",
    title: t("home.carousel.4.title"),
    description: t("home.carousel.4.desc"),
    linkText: t("home.carousel.4.cta")
  }
  // {
  //   image: "./Images/spa.png",
  //   title: "Step Arena Membership",
  //   description: "Unlimited use of Spa, pools, Fitness, and more. Plans tailored to your lifestyle and goals.",
  //   linkText: "ANËTARËSOHU TANI",
  // },
];

const SwimmingData = (t) => [
  { image: "./Images/swiming-activity1.png", title: t("home.swim.1") },
  { image: "./Images/swiming-activity2.png", title: t("home.swim.2") },
  { image: "./Images/swiming-activity3.png", title: t("home.swim.3") },
  { image: "./Images/swiming-activity4.png", title: t("home.swim.4") }
];

const GalleryImages1 = [
  // // { images: "./Images/gallery1.png", category: "HOTEL & RESTAURANT" },
  // { images: "./Images/gallery2.png", category: "OUTDOOR" },
  // { images: "./Images/gallery3.png", category: "OUTDOOR" },
  // // { images: "./Images/event1.png.png", category: "EVENTS" },
];

const GalleryImages2 = [
  // { images: "./Images/gallery5.png", category: "INDOOR" },
  // { images: "./Images/gallery6.png", category: "INDOOR" },
  // // { images: "./Images/gallery1.png", category: "HOTEL & RESTAURANT" }, // repeat, same category
  // { images: "./Images/gallery5.png", category: "INDOOR" },
];

const TestimonialData = (t) => [
  { names: "Njomza Aliu", description: t("home.testimonials.1.desc") },
  { names: "Ardian Fetahu", description: t("home.testimonials.2.desc") },
  { names: "Walter Rossi", description: t("home.testimonials.3.desc") },
  { names: "Shab's", description: t("home.testimonials.4.desc") }
];

const NewsData = (t) => [
  {
    title: t("home.news.list.1.title"),
    description: t("home.news.list.1.desc"),
    images: "./Images/competition1.png",
  },
  {
    title: t("home.news.list.2.title"),
    description: t("home.news.list.2.desc"),
    images: "./Images/competition2.png",
  },
  // {
  //   title: 'Çfarë e bën ndryshe orën e notit në STEP?',
  //   description: "…",
  //   images: "./Images/competition3.png",
  // },
];

const HOME = memo(() => {
  const { t } = useTranslation();

  const aboutRef = useRef(null);
  const [showFilled, setShowFilled] = useState(false);

  useEffect(() => {
    const observer = new IntersectionObserver(
      ([entry]) => setShowFilled(entry.isIntersecting),
      { threshold: 0.5 }
    );
    if (aboutRef.current) observer.observe(aboutRef.current);
    return () => {
      if (aboutRef.current) observer.unobserve(aboutRef.current);
    };
  }, []);

  const categories = [
    t("home.gallery.categories.all"),
    t("home.gallery.categories.outdoor"),
    t("home.gallery.categories.indoor"),
    t("home.gallery.categories.hotel"),
    t("home.gallery.categories.events"),
  ];
  const [activeCategory, setActiveCategory] = useState(t("home.gallery.categories.all"));

  // Merge all images into one flat array
  const allImages = [...GalleryImages1, ...GalleryImages2].flat();

  // Filter images based on active category
  const filteredImages =
    activeCategory === t("home.gallery.categories.all")
      ? allImages
      : allImages.filter((img) => img.category === activeCategory);

  return (
    <>
      {/* Carousel */}
      <div className="container-fluid px-0">
        <div id="carouselExampleIndicators" className="carousel slide" data-bs-ride="carousel">
          <div className="carousel-indicators">
            {carouselData(t).map((_, index) => (
              <button
                key={index}
                type="button"
                data-bs-target="#carouselExampleIndicators"
                data-bs-slide-to={index}
                className={index === 0 ? "active" : ""}
                aria-current={index === 0 ? "true" : undefined}
                aria-label={`Slide ${index + 1}`}
              ></button>
            ))}
          </div>

          <div className="carousel-inner">
            {carouselData(t).map((slide, index) => (
              <div
                className={`carousel-item ${index === 0 ? "active" : ""} carousel-container`}
                key={index}
              >
                <img
                  src={slide.image}
                  className="d-block w-100 carousel-image"
                  alt={slide.title}
                  loading={index === 0 ? "eager" : "lazy"}
                />
                <div className="carousel-caption d-flex flex-column justify-content-center text-start px-4 px-md-5 custom-caption-mobile-fix">
                  <h1
                    className="fw-bold mb-4 text-white"
                    style={{
                      fontSize: "clamp(1.8rem, 5vw, 3.5rem)",
                      textShadow: "2px 2px 8px rgba(0,0,0,0.7)",
                      lineHeight: "1.1",
                    }}
                  >
                    {slide.title}
                  </h1>
                  <p
                    className="mb-4 text-white"
                    style={{
                      fontSize: "clamp(1rem, 3vw, 1.3rem)",
                      textShadow: "1px 1px 4px rgba(0,0,0,0.6)",
                      maxWidth: "800px",
                      lineHeight: "1.5",
                    }}
                  >
                    {slide.description}
                  </p>
                  <a
                    href="#"
                    className="custom-membership-link2 fw-bold text-uppercase px-3 py-2 custom-button-fix"
                  >
                    <span className="d-inline-block w-100 text-center">{slide.linkText}</span>
                  </a>
                </div>
              </div>
            ))}
          </div>

          <button
            className="carousel-control-prev custom-carousel-btn"
            type="button"
            data-bs-target="#carouselExampleIndicators"
            data-bs-slide="prev"
          >
            <span className="carousel-control-prev-icon"></span>
            <span className="visually-hidden">Previous</span>
          </button>

          <button
            className="carousel-control-next custom-carousel-btn"
            type="button"
            data-bs-target="#carouselExampleIndicators"
            data-bs-slide="next"
          >
            <span className="carousel-control-next-icon"></span>
            <span className="visually-hidden">Next</span>
          </button>
        </div>
      </div>

      {/* About Section - No margin/padding to connect with carousel */}
      <div className="container-fluid bg-primary">
        <div className="row align-items-center min-vh-50">
          <div className="col-12 col-lg-6 px-0 position-relative" ref={aboutRef}>
            {/* Background Image */}
            <img
              src={AboutImg}
              alt="About Step Arena"
              className="img-fluid w-100 h-100 object-fit-cover"
              style={{ minHeight: "500px" }}
              loading="lazy"
            />

            {/* Full-cover SVG overlay */}
            {showFilled && (
              <img
                src={SvgFilled}
                alt="Filled Icon"
                className="position-absolute top-0 start-0 w-100 h-100 object-fit-cover svg-fill-animation"
                style={{ zIndex: 6 }}
              />
            )}
          </div>

          <div className="col-12 col-lg-6 text-white p-5">
            <h2 className="fw-bold mb-4" style={{ fontSize: "2.5rem", lineHeight: "1.2" }}>
              {t("home.about.title")}
            </h2>
            <p
              className="mb-4"
              style={{ fontSize: "1.1rem", lineHeight: "1.7", color: "rgba(255,255,255,0.9)" }}
            >
              {t("home.about.desc")}
            </p>

            <div className="mb-4">
              <p className="fw-bold mb-2" style={{ fontSize: "1.1rem" }}>
                {t("home.about.bullets.1")}
              </p>
              <p className="fw-bold mb-2" style={{ fontSize: "1.1rem" }}>
                {t("home.about.bullets.2")}
              </p>
              <p className="fw-bold mb-2" style={{ fontSize: "1.1rem" }}>
                {t("home.about.bullets.3")}
              </p>
              <p className="fw-bold mb-2" style={{ fontSize: "1.1rem" }}>
                {t("home.about.bullets.4")}
              </p>
            </div>

            <a
              href="/about"
              className="custom-membership-link1 fw-bold d-inline-flex align-items-center justify-content-center"
            >
              <span>{t("home.about.readMore")}</span>
            </a>
          </div>
        </div>
      </div>

      {/* Swimming Activity */}
      <section className="container-fluid py-0">
        <div className="row">
          {SwimmingData(t).map((slide, index) => (
            <div key={index} className="col-6 col-lg-3 px-0 hover-effect">
              <img
                src={slide.image}
                alt={slide.title}
                className="w-100 img-fluid"
                style={{ height: "600px", objectFit: "cover" }}
                loading="lazy"
              />
              <div className="hover-overlay"></div>
              <h2 className="content">{slide.title}</h2>
              <div className="hover-border"></div>
            </div>
          ))}
        </div>
      </section>

          {/* Swimming Program Section */}
          <section className="container-fluid py-4 py-md-5" style={{ backgroundColor: '#f8f9fa' }}>
            <div className="container">
              <div className="row align-items-center mb-4 mb-md-5">
                <div className="col-12 col-lg-6 mb-4 mb-lg-0">
                  <h2 
                    className="text-primary fw-bold mb-3 mb-md-4 text-center text-lg-start"
                    style={{ 
                      fontSize: 'clamp(1.8rem, 4vw, 2.5rem)', 
                      lineHeight: '1.2' 
                    }}
                  >
                    {t("swimming.title")}
                  </h2>
                  <div 
                    className="mb-3 mb-md-4 mx-auto mx-lg-0"
                    style={{
                      width: '60px',
                      height: '4px',
                      backgroundColor: '#1D3EE3',
                      borderRadius: '2px'
                    }}
                  ></div>
                  <p 
                    className="text-muted mb-3 mb-md-4 text-center text-lg-start"
                    style={{ 
                      fontSize: 'clamp(1rem, 2.5vw, 1.1rem)', 
                      lineHeight: '1.6' 
                    }}
                  >
                    {t("swimming.description")}
                  </p>
                  <p 
                    className="text-muted mb-3 mb-md-4 text-center text-lg-start"
                    style={{ 
                      fontSize: 'clamp(0.9rem, 2vw, 1rem)', 
                      lineHeight: '1.6' 
                    }}
                  >
                    {t("swimming.school")}
                  </p>
                  <div className="text-center text-lg-start">
                    <a 
                      href="/packages"
                      className="custom-membership-link1 fw-bold d-inline-flex align-items-center justify-content-center"
                      style={{ 
                        minWidth: '180px',
                        fontSize: 'clamp(0.9rem, 2vw, 1rem)',
                        padding: '12px 24px'
                      }}
                    >
                      <span>{t("swimming.seeMore")}</span>
                    </a>
                  </div>
                </div>
                <div className="col-12 col-lg-6">
                  <div className="row g-2 g-md-3">
                    <div className="col-6 col-sm-6 col-md-6 col-lg-6">
                      <div 
                        className="position-relative rounded-2 rounded-md-3 overflow-hidden h-100 swimming-card"
                        style={{ 
                          transition: 'all 0.3s ease',
                          cursor: 'pointer',
                          minHeight: 'clamp(150px, 25vw, 200px)',
                          maxHeight: '250px'
                        }}
                        onMouseEnter={(e) => {
                          if (window.innerWidth > 768) {
                            e.currentTarget.style.transform = 'translateY(-5px)';
                            e.currentTarget.style.boxShadow = '0 15px 40px rgba(0,0,0,0.2)';
                          }
                        }}
                        onMouseLeave={(e) => {
                          e.currentTarget.style.transform = 'translateY(0)';
                          e.currentTarget.style.boxShadow = 'none';
                        }}
                      >
                        {/* Cover Image */}
                        <img 
                          src="./Images/une-mundem.jpg" 
                          alt="Baby Swimming Program" 
                          className="w-100 h-100"
                          style={{ 
                            objectFit: 'cover',
                            minHeight: 'clamp(150px, 25vw, 200px)'
                          }}
                          onError={(e) => {
                            e.target.style.display = 'none';
                            e.target.nextSibling.style.display = 'block';
                          }}
                        />
                        {/* Fallback Background */}
                        <div 
                          className="w-100 h-100 d-flex flex-column align-items-center justify-content-center"
                          style={{ 
                            display: 'none',
                            backgroundColor: '#FF6B6B',
                            minHeight: 'clamp(150px, 25vw, 200px)',
                            background: 'linear-gradient(135deg, #FF6B6B 0%, #FF8E8E 100%)'
                          }}
                        >
                        </div>
                        
                        {/* Overlay Content */}
                        <div 
                          className="position-absolute bottom-0 start-0 w-100 text-white p-2 p-md-3"
                          style={{
                            background: 'linear-gradient(transparent, rgba(0,0,0,0.8))',
                            backdropFilter: 'blur(2px)'
                          }}
                        >
                          <h6 className="fw-bold mb-1" style={{ 
                            fontSize: 'clamp(0.8rem, 2vw, 1rem)', 
                            marginBottom: '2px' 
                          }}>
                            {t("swimming.levels.level1.title")}
                          </h6>
                          <small style={{ 
                            fontSize: 'clamp(0.7rem, 1.5vw, 0.8rem)', 
                            opacity: '0.9' 
                          }}>0-3 vjeç</small>
                        </div>
                      </div>
                    </div>
                    <div className="col-6 col-sm-6 col-md-6 col-lg-6">
                      <div 
                        className="position-relative rounded-2 rounded-md-3 overflow-hidden h-100 swimming-card"
                        style={{ 
                          transition: 'all 0.3s ease',
                          cursor: 'pointer',
                          minHeight: 'clamp(150px, 25vw, 200px)',
                          maxHeight: '250px'
                        }}
                        onMouseEnter={(e) => {
                          if (window.innerWidth > 768) {
                            e.currentTarget.style.transform = 'translateY(-5px)';
                            e.currentTarget.style.boxShadow = '0 15px 40px rgba(0,0,0,0.2)';
                          }
                        }}
                        onMouseLeave={(e) => {
                          e.currentTarget.style.transform = 'translateY(0)';
                          e.currentTarget.style.boxShadow = 'none';
                        }}
                      >
                        {/* Cover Image */}
                        <img 
                          src="./Images/preeschool.jpg" 
                          alt="Preschool Swimming Program" 
                          className="w-100 h-100"
                          style={{ 
                            objectFit: 'cover',
                            minHeight: 'clamp(150px, 25vw, 200px)'
                          }}
                          onError={(e) => {
                            e.target.style.display = 'none';
                            e.target.nextSibling.style.display = 'block';
                          }}
                        />
                        {/* Fallback Background */}
                        <div 
                          className="w-100 h-100 d-flex flex-column align-items-center justify-content-center"
                          style={{ 
                            display: 'none',
                            backgroundColor: '#4ECDC4',
                            minHeight: 'clamp(150px, 25vw, 200px)',
                            background: 'linear-gradient(135deg, #4ECDC4 0%, #6ED5CD 100%)'
                          }}
                        >
                        </div>
                        
                        {/* Overlay Content */}
                        <div 
                          className="position-absolute bottom-0 start-0 w-100 text-white p-2 p-md-3"
                          style={{
                            background: 'linear-gradient(transparent, rgba(0,0,0,0.8))',
                            backdropFilter: 'blur(2px)'
                          }}
                        >
                          <h6 className="fw-bold mb-1" style={{ 
                            fontSize: 'clamp(0.8rem, 2vw, 1rem)', 
                            marginBottom: '2px' 
                          }}>
                            {t("swimming.levels.level2.title")}
                          </h6>
                          <small style={{ 
                            fontSize: 'clamp(0.7rem, 1.5vw, 0.8rem)', 
                            opacity: '0.9' 
                          }}>3-6 vjeç</small>
                        </div>
                      </div>
                    </div>
                    <div className="col-6 col-sm-6 col-md-6 col-lg-6">
                      <div 
                        className="position-relative rounded-2 rounded-md-3 overflow-hidden h-100 swimming-card"
                        style={{ 
                          transition: 'all 0.3s ease',
                          cursor: 'pointer',
                          minHeight: 'clamp(150px, 25vw, 200px)',
                          maxHeight: '250px'
                        }}
                        onMouseEnter={(e) => {
                          if (window.innerWidth > 768) {
                            e.currentTarget.style.transform = 'translateY(-5px)';
                            e.currentTarget.style.boxShadow = '0 15px 40px rgba(0,0,0,0.2)';
                          }
                        }}
                        onMouseLeave={(e) => {
                          e.currentTarget.style.transform = 'translateY(0)';
                          e.currentTarget.style.boxShadow = 'none';
                        }}
                      >
                        {/* Cover Image */}
                        <img 
                          src="./Images/1-10 vjec.jpg" 
                          alt="Learn Swimming Program" 
                          className="w-100 h-100"
                          style={{ 
                            objectFit: 'cover',
                            minHeight: 'clamp(150px, 25vw, 200px)'
                          }}
                          onError={(e) => {
                            e.target.style.display = 'none';
                            e.target.nextSibling.style.display = 'block';
                          }}
                        />
                        {/* Fallback Background */}
                        <div 
                          className="w-100 h-100 d-flex flex-column align-items-center justify-content-center"
                          style={{ 
                            display: 'none',
                            backgroundColor: '#45B7D1',
                            minHeight: 'clamp(150px, 25vw, 200px)',
                            background: 'linear-gradient(135deg, #45B7D1 0%, #6BC5E0 100%)'
                          }}
                        >
                        </div>
                        
                        {/* Overlay Content */}
                        <div 
                          className="position-absolute bottom-0 start-0 w-100 text-white p-2 p-md-3"
                          style={{
                            background: 'linear-gradient(transparent, rgba(0,0,0,0.8))',
                            backdropFilter: 'blur(2px)'
                          }}
                        >
                          <h6 className="fw-bold mb-1" style={{ 
                            fontSize: 'clamp(0.8rem, 2vw, 1rem)', 
                            marginBottom: '2px' 
                          }}>
                            {t("swimming.levels.level3.title")}
                          </h6>
                          <small style={{ 
                            fontSize: 'clamp(0.7rem, 1.5vw, 0.8rem)', 
                            opacity: '0.9' 
                          }}>6-17 vjeç</small>
                        </div>
                      </div>
                    </div>
                    <div className="col-6 col-sm-6 col-md-6 col-lg-6">
                      <div 
                        className="position-relative rounded-2 rounded-md-3 overflow-hidden h-100 swimming-card"
                        style={{ 
                          transition: 'all 0.3s ease',
                          cursor: 'pointer',
                          minHeight: 'clamp(150px, 25vw, 200px)',
                          maxHeight: '250px'
                        }}
                        onMouseEnter={(e) => {
                          if (window.innerWidth > 768) {
                            e.currentTarget.style.transform = 'translateY(-5px)';
                            e.currentTarget.style.boxShadow = '0 15px 40px rgba(0,0,0,0.2)';
                          }
                        }}
                        onMouseLeave={(e) => {
                          e.currentTarget.style.transform = 'translateY(0)';
                          e.currentTarget.style.boxShadow = 'none';
                        }}
                      >
                        {/* Cover Image */}
                        <img 
                          src="./Images/pro.jpg" 
                          alt="Elite Swimming Academy" 
                          className="w-100 h-100"
                          style={{ 
                            objectFit: 'cover',
                            minHeight: 'clamp(150px, 25vw, 200px)'
                          }}
                          onError={(e) => {
                            e.target.style.display = 'none';
                            e.target.nextSibling.style.display = 'block';
                          }}
                        />
                        {/* Fallback Background */}
                        <div 
                          className="w-100 h-100 d-flex flex-column align-items-center justify-content-center"
                          style={{ 
                            display: 'none',
                            backgroundColor: '#96CEB4',
                            minHeight: 'clamp(150px, 25vw, 200px)',
                            background: 'linear-gradient(135deg, #96CEB4 0%, #B4D4C4 100%)'
                          }}
                        >
                        </div>
                        
                        {/* Overlay Content */}
                        <div 
                          className="position-absolute bottom-0 start-0 w-100 text-white p-2 p-md-3"
                          style={{
                            background: 'linear-gradient(transparent, rgba(0,0,0,0.8))',
                            backdropFilter: 'blur(2px)'
                          }}
                        >
                          <h6 className="fw-bold mb-1" style={{ 
                            fontSize: 'clamp(0.8rem, 2vw, 1rem)', 
                            marginBottom: '2px' 
                          }}>
                            {t("swimming.levels.level4.title")}
                          </h6>
                          <small style={{ 
                            fontSize: 'clamp(0.7rem, 1.5vw, 0.8rem)', 
                            opacity: '0.9' 
                          }}>Elite</small>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </section>

      {/* Gallery Details */}
      <div className="container my-5">
        <div className="row gallery-details-container ">
          <div className="col-12 text-center">
            <h3
              className="text-primary fw-bold mb-3"
              style={{ fontSize: "2rem", textAlign: "center" }}
            >
              {t("home.gallery.title")}
            </h3>
          </div>
        </div>
      </div>

      {/* Gallery Section */}
      <div className="text-center mb-4 category-tabs">
        {categories.map((cat) => (
          <span
            key={cat}
            onClick={() => setActiveCategory(cat)}
            className={`category-item ${activeCategory === cat ? "active" : ""}`}
          >
            {cat}
          </span>
        ))}
      </div>

      <section className="container-fluid mb-5">
        <div className="row g-2 mb-2">
          {filteredImages.map((slide, index) => (
            <div key={index} className="col-6 col-md-3 p-1 d-flex gallery-control">
              <img
                src={slide.images}
                alt={`Gallery ${index + 1}`}
                className="img-fluid w-100"
                style={{ height: "350px", objectFit: "cover" }}
                loading="lazy"
              />
            </div>
          ))}
        </div>
      </section>

      {/* Testimonial Section */}
      <section className="container-fluid testimonial pb-5">
        <div className="container">
          <div className="row mb-5 testimonial-head text-white">
            <div className="col-md-5 p-5">
              <p
                className="mb-2 text-uppercase"
                style={{ fontSize: "0.9rem", letterSpacing: "2px", color: "rgba(255,255,255,0.8)" }}
              >
                {t("home.testimonials.sectionLabel")}
              </p>
              <h3 className="fw-bold" style={{ fontSize: "2.5rem", lineHeight: "1.2" }}>
                {t("home.testimonials.heading")}
              </h3>
            </div>
            <div className="col-md-7 p-5">{/* reserved copy */}</div>
          </div>

          <div className="row g-4">
            {TestimonialData(t).map((slide, index) => (
              <div className="col-12 col-lg-3 col-md-6" key={index}>
                <div className="testimonial-details text-center text-white p-4 h-100">
                  <i className="fa-solid fa-quote-right pb-3 fs-2"></i>
                  <p className="mb-4" style={{ fontSize: "0.95rem", lineHeight: "1.6" }}>
                    {slide.description}
                  </p>

                  <div className="my-4">
                    {Array.from({ length: 5 }).map((_, i) => (
                      <i key={i} className="fa-solid fa-star text-warning me-1"></i>
                    ))}
                  </div>

                  <div className="ellipse d-flex flex-column align-items-center">
                    <h6 className="fw-bold">{slide.names}</h6>
                  </div>
                </div>
              </div>
            ))}
          </div>
        </div>
      </section>

      {/* News Section */}
      <section className="news-section my-5">
        <div className="px-4 px-md-5 px-lg-6">
          <div className="row news-details-container mb-5 text-center text-md-start">
            <div className="col-12 col-md-8">
              <h3 className="text-primary fw-bold mb-3" style={{ fontSize: "3rem" }}>
                {t("home.news.heading")}
              </h3>
            </div>
            <div className="col-12 col-md-4 text-md-end mt-3 mt-md-0">{/* CTA reserved */}</div>
          </div>

          <div className="row">
            <div className="col-12 col-lg-6 px-0 competition-container mb-5 mb-lg-0">
              <img
                src="Images/competition-background.png"
                alt="Competition Background"
                className="img-fluid w-100"
                loading="lazy"
              />
              <div className="competition-data p-4 newsz-details shadow">
                <p className="text-muted mb-2" style={{ fontSize: "0.9rem" }}>
                  {t("home.news.featured.date")}
                </p>
                <h5 className="text-primary fw-bold mb-3">
                  {t("home.news.featured.title")}
                </h5>
                <p style={{ fontSize: "0.95rem", lineHeight: "1.6" }}>
                  {t("home.news.featured.desc")}
                </p>
              </div>
            </div>

            <div className="col-12 col-lg-6 ps-lg-4 ps-0 d-flex flex-column justify-content-center">
              {NewsData(t).map((slide, index) => (
                <div className="row mb-4" key={index}>
                  <div className="col-12 col-md-4 px-0 mb-3 mb-lg-0">
                    <img
                      src={slide.images}
                      alt={slide.title}
                      className="img-fluid w-100 h-100 rounded"
                      style={{ minHeight: "120px", objectFit: "cover" }}
                      loading="lazy"
                    />
                  </div>
                  <div className="col-12 col-md-8 px-4 newsz-details">
                    <p className="text-muted mb-1" style={{ fontSize: "0.85rem" }}>
                      {t("home.news.listDate")}
                    </p>
                    <h6
                      className="text-primary fw-bold mb-2"
                      style={{ fontSize: "1rem", lineHeight: "1.3" }}
                    >
                      {slide.title}
                    </h6>
                    <p className="mb-0" style={{ fontSize: "0.9rem", lineHeight: "1.5" }}>
                      {slide.description}
                    </p>
                  </div>
                </div>
              ))}
            </div>
          </div>
        </div>
      </section>

    </>
  );
});

HOME.displayName = "HOME";

export default HOME;
